<template>
  <div>
    <my-head></my-head>
    <div class="shourang minH">
      <div class="title">查看受让的标</div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="产权概况" name="1">
          <p class="tab_title">产权概况</p>

          <div class="jie_shao" style="margin-top: 24px">
            <div>
              <div class="xiang_xi">
                <div
                  v-if="getListingDisplayPrice(data.markRelease) || getListingDisplayPrice(data.markRelease) === 0"
                  class="jia_ge flex-left-center"
                >
                  <span>{{ priceCurrencyPrefix(data.markRelease.foreignType) }} </span>
                  {{ getListingDisplayPrice(data.markRelease) }}
                  <span style="margin-left: 6px">万元</span>
                </div>

                <div v-else class="jia_ge flex-left-center">面议</div>

                <div class="biao_qian flex-left">
                  <div class="flex-center" v-show="data.markRelease.region">
                    {{ data.markRelease.region }}
                  </div>

                  <div
                    class="flex-center"
                    v-show="data.markRelease.propertyCategory"
                  >
                    {{ data.markRelease.propertyCategory }}
                  </div>

                  <div
                    class="flex-center"
                    v-show="data.markRelease.propertyCategory == '专利'"
                    v-for="(item, index) in typelist"
                    :key="index"
                  >
                    {{ item }}
                  </div>

                  <div
                    class="flex-center"
                    v-show="data.markRelease.projectDomain"
                  >
                    {{ data.markRelease.projectDomain }}
                  </div>
                </div>

                <div class="xi_jie flex-left flex-wrap">
                  <div>
                    项目所在国家/地区：
                    <span>{{ data.markRelease.regionName }}</span>
                  </div>

                  <div>
                    受托机构联系人：
                    <span v-if="data.markRelease.applicantType == '自然人'">
                      {{ data.markRelease.transferorName }}
                    </span>
                    <span v-else>
                      {{ data.markRelease.linkman }}
                    </span>
                  </div>

                  <div>
                    知识产权类别：
                    <span>{{
                      data.markRelease.propertyCategory == "其他"
                        ? data.markRelease.propertyCategoryExtra
                        : data.markRelease.propertyCategory
                    }}</span>
                  </div>

                  <div>
                    交易方式：
                    <span>{{ data.markRelease.dealWay }}</span>
                  </div>
                </div>

                <div style="border-top: 1px solid #e5e6eb; width: 100%"></div>
                <div class="gong_si flex-left-center">
                  <div class="xin_xi flex-left flex-wrap">
                    <div class="flex-left-center">
                      申请人：
                      <span>{{ data.markRelease.transferorName }}</span>
                    </div>
                    <div class="flex-left-center">
                      电话：
                      <span>{{
                        data.markRelease.phone || data.markRelease.contactNumber
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <el-form label-width="100px">
            <el-form-item label="项目编号">
              {{ data.markRelease.code }}
            </el-form-item>

            <el-form-item label="是否联合受让" prop="theJoint">
              {{ data.markRelease.theJoint }}
            </el-form-item>
            <el-form-item label="知识产权名称" prop="name">
              {{ data.markRelease.name }}
            </el-form-item>
            <el-form-item label="主分类号" prop="fenlei">
              {{ data.markRelease.fenlei }}
            </el-form-item>
            <el-form-item label="知产类型" prop="propertyCategory">
              {{ data.markRelease.propertyCategory }}
            </el-form-item>
            <el-form-item label="发布时间" prop="createTime">
              {{ data.markRelease.createTime }}
            </el-form-item>
            <el-form-item label="是否国际">
              {{ data.markRelease.region == "境外" ? "是" : "否" }}
            </el-form-item>
            <el-form-item label="专利类型">
              {{ data.markRelease.patentType }}
            </el-form-item>
            <el-form-item label="所属分类">
              {{ data.markRelease.propertyCategory }}
            </el-form-item>
            <el-form-item label="拟受让底价" prop="floorPrice">
              {{
                (getListingDisplayPrice(data.markRelease) || getListingDisplayPrice(data.markRelease) === 0)
                  ? priceCurrencyPrefix(data.markRelease.foreignType) +
                    " " +
                    getListingDisplayPrice(data.markRelease) +
                    "万元"
                  : "面议"
              }}
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="意向受让方信息" name="2">
          <p class="tab_title">意向受让方信息</p>
          <el-form label-width="140px">
            <el-form-item label="意向受让方类型">
              <span v-show="data.type == 2">企业</span>
              <span v-show="data.type == 3">第三方企业</span>
              <span v-show="data.type == 1">个人</span>
            </el-form-item>

            <div v-if="data.type == 2 || data.type == 3">
              <el-form-item label="意向受让方名称" prop="yxmingcheng">
                {{ data.enterprisePO.name }}
              </el-form-item>
              <el-form-item label="注册地址" prop="domicile">
                {{ data.enterprisePO.domicile }}
              </el-form-item>
              <el-form-item label="法定代表人" prop="legalPerson">
                {{ data.enterprisePO.legalPerson }}
              </el-form-item>
              <el-form-item label="注册资本" prop="registeredCapital">
                {{ data.enterprisePO.registeredCapital }}
              </el-form-item>
              <el-form-item label="统一社会信用代码" prop="code">
                {{ data.enterprisePO.code }}
              </el-form-item>
              <el-form-item label="经营范围" prop="businessScope">
                {{ data.enterprisePO.businessScope }}
              </el-form-item>
              <el-form-item label="联系人" prop="contactPerson">
                {{ data.enterprisePO.contactPerson }}
              </el-form-item>
              <el-form-item label="联系电话" prop="contactPhone">
                {{ data.enterprisePO.contactPhone }}
              </el-form-item>
              <el-form-item label="电子邮箱" prop="email">
                {{ data.enterprisePO.email }}
              </el-form-item>
              <el-form-item label="通讯地址" prop="address">
                {{ data.enterprisePO.address }}
              </el-form-item>
              <el-form-item label="内部决策情况">
                <div>
                  以下决议已按公司法及其他有关法律法规要求完成，议事规则和决策程序符合规定。
                </div>
                <div>
                  {{ data.enterprisePO.innerDecision }}
                </div>
              </el-form-item>
            </div>

            <div v-else-if="data.type == 1">
              <el-form-item label="意向受让人名称" prop="name">
                {{ realnameAuthPO.name }}
              </el-form-item>
              <el-form-item label="联系人">
                {{ realnameAuthPO.name }}
              </el-form-item>
              <el-form-item label="联系电话">
                {{ realnameAuthPO.phone }}
              </el-form-item>
              <el-form-item label="电子邮箱">
                {{ realnameAuthPO.email }}
              </el-form-item>
              <el-form-item label="通讯地址">
                {{ realnameAuthPO.actualAddress }}
              </el-form-item>
            </div>

            <el-form-item label="是否为关联方">
              {{ data.isAssoc == "0" ? "否" : "是" }}
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="受让意愿与承诺" name="3">
          <p class="tab_title">意向受让方信息</p>
          <div class="cheng_nuo">{{ data.promiseText }}</div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { getRequest } from "../../api/api";
import { getUSER } from "../../api/constant";
import { priceCurrencyPrefix, getListingDisplayPrice } from "../../api/util";
export default {
  components: {
    MyHead,
    MyFooter,
  },
  data() {
    return {
      activeName: "1", //tab选项 产权概况(1)意向受让方信息(2)受让意愿与承诺(3)
      data: {
        markRelease: {}, //标的介绍
        enterprisePO: {}, //企业
      },
      realnameAuthPO: {}, //个人
      cardwidth: 100,
      cardsleft: 0,
      pingFen: 4.7,
      imgList: [],
      img: null,
      typelist: [], //当产权类别为专利时的专利列表
    };
  },
  methods: {
    priceCurrencyPrefix,
    getListingDisplayPrice,
    cardsZ() {
      if (this.cardsleft < 0) {
        this.cardsleft += this.cardwidth;
      }
    },
    cardsY() {
      this.cardsleft -= this.cardwidth;
    },
    getData(id) {
      getRequest({ url: `/api/v1/markReleaseRecv/getOne/${id}` }).then(
        (res) => {
          if ((res.errcode = 200)) {
            this.data = res.data;

            this.typelist = res.data.markRelease.patentType
              ? String(res.data.markRelease.patentType)
                  .split(",")
                  .filter(Boolean)
              : [];

            if (res.data.markRelease.imageUrl) {
              this.imgList = JSON.parse(res.data.markRelease.imageUrl);
              this.img = this.imgList[0];
            }
            if (res.data.type == 1) {
              this.getGr(id);
            }
          } else {
            this.$message.error(res.errmsg);
          }
        }
      );
    },
    getGr(id) {
      let user = getUSER();
      getRequest({
        url: `/api/v1/markReleaseRecv/getRealnameAuth?id=${user.id}`,
      }).then((res) => {
        this.realnameAuthPO = res.data;
        console.log("this.realnameAuthPO", this.realnameAuthPO);
      });
    },
  },
  created() {
    let { id } = this.$route.query;
    this.getData(id);
  },
};
</script>

<style lang="scss">
.shourang {
  width: 80%;
  margin: 24px auto 60px;
  .cheng_nuo {
    margin-top: 28px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 300;
    color: #333333;
    border: #4e5969 solid 1px;
    border-radius: 12px;
    padding: 24px;
  }

  .jie_shao {
    margin-bottom: 80px;
    & > div {
      // width: 48%;
      .dian_ji {
        font-size: 12px;
        font-weight: 400;
        color: #86909c;
        line-height: 20px;
        span {
          color: #165dff;
        }
      }
      .buttons {
        width: 240px;
        font-size: 14px;
        font-weight: 500;
        img {
          width: 14px;
          margin-right: 8px;
        }
        .shou_rang {
          background: #165dff;
          color: #ffffff;
        }
        .shou_cang {
          color: #165dff;
        }
        .shou_cang_yi {
          color: #4e5969;
          border: none;
          background: #f2f3f5;
        }
        & > div {
          width: 114px;
          height: 36px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #165dff;
          cursor: pointer;
        }
      }
      .gong_si {
        margin: 24px 0;
        .xin_xi {
          font-size: 14px;
          font-weight: 400;
          color: #86909c;
          line-height: 22px;
          & > div {
            margin-right: 16px;
            span {
              font-size: 16px;
              font-weight: 500;
              color: #1d2129;
              line-height: 24px;
            }
          }
        }
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 1px solid #e5e6eb;
          margin-right: 12px;
        }
      }
      .xi_jie {
        padding-top: 12px;
        & > div {
          margin-right: 24px;
          font-size: 14px;
          font-weight: 400;
          color: #86909c;
          line-height: 22px;
          margin-bottom: 12px;
          span {
            color: #1d2129;
          }
        }
      }
      .ping_fen {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        margin: 24px 0 12px;
      }
      .biao_qian {
        margin-bottom: 24px;
        & > div {
          height: 24px;
          background: #e8f3ff;
          border-radius: 2px 2px 2px 2px;
          font-size: 12px;
          font-weight: 400;
          color: #165dff;
          padding: 0 12px;
          margin-right: 8px;
        }
      }
      .xiang_xi {
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e6eb;
        padding: 24px;
        .jia_ge {
          font-size: 24px;
          font-weight: bold;
          color: #eb5757;
          line-height: 32px;
          margin-bottom: 16px;
          span {
            font-size: 24px;
            margin-right: 4px;
          }
        }
      }
      .list {
        height: 66px;
        overflow: hidden;
        width: 88%;
        .col {
          width: 76px;
          height: 66px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #4e5969;
          margin: 0 12px;
          cursor: pointer;
        }
      }
      .tu_list {
        width: 100%;
        .fan_ye {
          width: 16px;
          height: 48px;
          background: #f2f3f5;
          border-radius: 2px 2px 2px 2px;
          cursor: pointer;
        }
      }
      .tu {
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e6eb;
        padding: 20px;
        margin-bottom: 24px;
        // img {
        //   width: 100%;
        // }
      }
    }
  }
  .el-form {
    margin: 30px 0;
  }
  .tab_title {
    font-size: 18px;
    font-weight: 500;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }
}
</style>
